import React from 'react';
import {
  ResponsiveContainer,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Radar,
  Legend,
} from 'recharts';
import { theme } from '../../theme';
import { useLanguage } from '../../i18n';
import type { SovObjective } from '../../types/workplace';

interface SovRadarChartProps {
  istScores?: Record<string, number>;
  zielScores?: Record<string, number>;
  sovObjectives: SovObjective[];
}

const sovI18nKeys: Record<string, string> = {
  'sov-1': 'workplace.sov.sov1',
  'sov-2': 'workplace.sov.sov2',
  'sov-3': 'workplace.sov.sov3',
  'sov-4': 'workplace.sov.sov4',
  'sov-5': 'workplace.sov.sov5',
  'sov-6': 'workplace.sov.sov6',
  'sov-7': 'workplace.sov.sov7',
  'sov-8': 'workplace.sov.sov8',
};

export const SovRadarChart: React.FC<SovRadarChartProps> = ({
  istScores,
  zielScores,
  sovObjectives,
}) => {
  const { t } = useLanguage();

  const data = sovObjectives.map((obj) => ({
    subject: t(sovI18nKeys[obj.id] as any) || obj.name,
    ist: istScores?.[obj.id] ?? 0,
    ...(zielScores ? { ziel: zielScores[obj.id] ?? 0 } : {}),
    fullMark: 4,
  }));

  return (
    <ResponsiveContainer width="100%" height={350}>
      <RadarChart data={data}>
        <PolarGrid stroke={theme.border} />
        <PolarAngleAxis dataKey="subject" tick={{ fill: theme.text, fontSize: 11 }} />
        <PolarRadiusAxis angle={90} domain={[0, 4]} tick={{ fill: theme.muted, fontSize: 10 }} />
        <Radar
          name="Ist"
          dataKey="ist"
          stroke={theme.primary}
          fill={theme.primary}
          fillOpacity={0.25}
          strokeWidth={2}
        />
        {zielScores && (
          <Radar
            name="Ziel"
            dataKey="ziel"
            stroke={theme.secondary}
            fill={theme.secondary}
            fillOpacity={0.25}
            strokeWidth={2}
          />
        )}
        <Legend />
      </RadarChart>
    </ResponsiveContainer>
  );
};
